import { render, staticRenderFns } from "./Input_Repeater.vue?vue&type=template&id=24bbbb54&scoped=true&"
import script from "./Input_Repeater.vue?vue&type=script&lang=js&"
export * from "./Input_Repeater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbbb54",
  null
  
)

export default component.exports